<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { valueOutOfRange } from '../../../../helpers/utilities';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
		//Design system components
	import { Text, Input, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore,
		min = 0,
		max = 100000;

	let dark = settings.dark_threshold,
		dusk = settings.twilight_threshold,
		waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const res = await postReq(`/device/${device.category}/settings/door_sensor_dark_dusk`, {
			id,
			dark,
			dusk,
		});
		const toastTexts = {
			success: $format('illumination_set_scc_toast', {
				default: 'Illumination definitions set successfully.',
			}),
			danger: $format('illumination_set_err_toast', {
				default: 'Failed to set illumination definitions.',
			}),
		};
		onSettingsResponse(res, device, toastTexts);
		waitForResponse = false;
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('illumination_set_dark', { default: 'Set dark:' })}</Text
>
<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	bind:value={dark}
	error={valueOutOfRange(dark, min, dusk)
		? $format('min_max_error_description', {
				values: { min, max: dusk },
				default: 'Value must be between {min} and {max}.',
			})
		: ''}
	aria-label={$format('illumination_set_dark', { default: 'Set dark' })}
	id="input-r68kr20"
/>

<Text styleType="body-small" class="mb-s"
	>{$format('illumination_set_dusk', { default: 'Set dusk:' })}</Text
>
<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	bind:value={dusk}
	error={valueOutOfRange(dusk, dark, max)
		? $format('min_max_error_description', {
				values: { min: dark, max },
				default: 'Value must be between {min} and {max}.',
			})
		: ''}
	aria-label={$format('illumination_set_dusk', { default: 'Set dusk' })}
	id="input-zbrtzec"
/>

<Button
	size="m"
	width="full"
	loading={waitForResponse}
	disabled={valueOutOfRange(dusk, dark, max) || valueOutOfRange(dark, min, dusk)}
	on:click={save}>{$format('button_save', { default: 'Save' })}</Button
>
